import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LocalService, ManagerService } from 'src/app/core';
import { SellerRewardsDialogComponent } from 'src/app/shared';
import {
  ProgressInfoPopupComponent
} from 'src/app/shared/components/progress-info-popup/progress-info-popup/progress-info-popup.component';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-view-leaderboard-cards',
  templateUrl: './view-leaderboard-cards.component.html',
  styleUrls: ['./view-leaderboard-cards.component.scss']
})
export class ViewLeaderboardCardsComponent implements OnInit, OnDestroy {

  constructor(private managerService: ManagerService, private popupMessageService: PopupMessageService,
    private dialog: MatDialog) { }
  @Input() user: any;
  userProfile: any;
  pageNo: number = 1;
  pageSize: number = 4;
  leaderboardChallenges: any;
  selectedChallenge: any = null;
  isDrawerOpen = false;
  isTermsOpen = false;
  termsChallenge: any = null;
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.getLeaderBoardChallengesList()

    
  }

  getLeaderBoardChallengesList(pageNo?: any) {
    
    if (pageNo != undefined) {
      this.pageNo=pageNo
    }

    const params: any = {
      page: this.pageNo-1,
      size: this.pageSize,
      userId: this.userProfile.id
    };

    if (this.user === 'leader') {
      params['companyId'] = this.userProfile.company.id;

      this.managerService.getLeaderBoardChallengesListLeader(params).subscribe((data: any) => {
        // console.log(data)
        this.leaderboardChallenges = data
      }, (_err: any) => {
        //this.errors = err;
        this.popupMessageService.showError('Something went wrong', 'error');
      });
    } else {
      this.managerService.getLeaderBoardChallengesListSeller(params).subscribe((data: any) => {
        console.log(data)
        this.leaderboardChallenges = data
      }, (_err: any) => {
        //this.errors = err;
        this.popupMessageService.showError('Something went wrong', 'error');
      });
    }
  }



  getTotalAchieved(list: any): number {
    const targets = list && list.progressInfo && list.progressInfo.targetsProgressInfo;
    if (!targets || !targets.length) return 0;
    return targets.reduce((sum: number, t: any) => sum + (t.achievedBookings || 0), 0);
  }

  getTotalTarget(list: any): number {
    const targets = list && list.progressInfo && list.progressInfo.targetsProgressInfo;
    if (!targets || !targets.length) return 0;
    return targets.reduce((sum: number, t: any) => sum + (t.targetBookings || 0), 0);
  }

  getOverallProgress(list: any): number {
    const target = this.getTotalTarget(list);
    if (!target) return 0;
    return Math.min(Math.round((this.getTotalAchieved(list) / target) * 100), 100);
  }

  formatDate(date: string): string {
    const month = Number(date.substring(5, 7).replace(/^0+/, ''));
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month - 1]} ${day}, ${year}`;
  };
  showProgressInfo(list: any){
    this.managerService.getLeaderboardChgProgress(list.userLeaderboardChallengeId).subscribe((data: any) => {
      // console.log(data)
      if (data) {
        data.challengeName = list.name;
        this.dialog.open(ProgressInfoPopupComponent, {
          data,
          width: "50%",
          height: "500px",
          panelClass: 'progress-info',
        });
      };
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  showSampleProgressInfo() {
    const sampleData = {
      challengeName: 'Q2 Networking Sales Challenge',
      participantGroupName: 'CISCO-PARTNER-001',
      targetsProgressInfo: [
        { targetName: 'Catalyst 9000 Series', targetBookings: 500000, achievedBookings: 375000, progress: 75 },
        { targetName: 'Meraki MX Appliances', targetBookings: 200000, achievedBookings: 160000, progress: 80 },
        { targetName: 'Webex Collaboration Suite', targetBookings: 150000, achievedBookings: 45000, progress: 30 },
        { targetName: 'SecureX Platform', targetBookings: 100000, achievedBookings: 102000, progress: 102 },
      ]
    };
    this.dialog.open(ProgressInfoPopupComponent, {
      data: sampleData,
      width: '50%',
      height: '500px',
      panelClass: 'progress-info',
    });
  };

  getStatus(check: any, completedBy: any, creationDate: string, startDate: string): string {
    const lang = localStorage.getItem('selectedLanguage');
    let value = '';
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = (completedBy && this.setTime(completedBy.split('T')[0]) || null);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > (completeByDate && completeByDate.getTime() || 0);
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) {
        value = '닫은';
      }
      if (creationOn && pending) {
        value = '대기 중';
      }
      if (check) {
        value = '';
      }
    }
    else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) {
        value = '閉まっている';
      }
      if (creationOn && pending) {
        value = '保留中';
      }
      if (check) {
        value = '';
      }
    }
    else if (lang == 'English') {
      value = 'Open';
      if (!check && isExpired) {
        value = 'Closed';
      }
      if (creationOn && pending) {
        value = 'Pending';
      }
      if (check) {
        value = '';
      }
    }
    return value;
  };

  setTime(date: any): Date {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  };

  openDrawer(challenge: any) {
    // TODO: Uncomment API call once backend is ready
    // this.managerService.getLeaderboardChgProgress(challenge.userLeaderboardChallengeId).subscribe(
    //   (data) => {
    //     this.selectedChallenge = challenge;
    //     this.selectedChallenge.progressData = data || null;
    //     const hasProgress = data && data.targetsProgressInfo && data.targetsProgressInfo.length;
    //     this.selectedChallenge.progressState = hasProgress ? 'loaded' : 'empty';
    //     this.isDrawerOpen = true;
    //   },
    //   (_err) => {
    //     this.selectedChallenge = challenge;
    //     this.selectedChallenge.progressData = null;
    //     this.selectedChallenge.progressState = 'error';
    //     this.isDrawerOpen = true;
    //   }
    // );

    // Hardcoded sample data for testing
    const data = {
      participantGroupName: 'CISCO-PARTNER-001',
      targetsProgressInfo: [
        { targetName: 'Catalyst 9000 Series', targetBookings: 500000, achievedBookings: 375000, progress: 75 },
        { targetName: 'Meraki MX Appliances', targetBookings: 200000, achievedBookings: 160000, progress: 80 },
        { targetName: 'Webex Collaboration Suite', targetBookings: 150000, achievedBookings: 45000, progress: 30 },
        { targetName: 'SecureX Platform', targetBookings: 100000, achievedBookings: 102000, progress: 102 },
      ]
    };

    this.selectedChallenge = challenge;
    this.selectedChallenge.progressData = data || null;
    this.selectedChallenge.progressState = (data && data.targetsProgressInfo && data.targetsProgressInfo.length) ? 'loaded' : 'empty';
    this.isDrawerOpen = true;
  }

  closeDrawer() {
    this.isDrawerOpen = false;
  }

  openTermsModal(challenge: any) {
    this.termsChallenge = challenge;
    this.isTermsOpen = true;
  }

  closeTermsModal() {
    this.isTermsOpen = false;
    this.termsChallenge = null;
  }

  downloadList(data: any){
    if(data!=null ){
      const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {

        data: { 'name': 'downloadAttachments','filaeData':data},
        width:'40%',
        panelClass:'download-doc-popup'
      });
      dialogRef.afterClosed().subscribe((_result: any) => {
      });
    }
  }

  ngOnDestroy(): void {
    const ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    if (ciscoLinkElement) {
      document.head.removeChild(ciscoLinkElement);
    };
  };

}
